module.exports = __webpack_public_path__ + "img/old_icon.39c4c385.png";